import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function ModelNotAvailableButton() {
  return (
    <Button
      type="primary-warning"
      customClass="pricing-area__actions-button pricing-area__model-not-available-button"
      size="large"
      disabled
      aria-label="The model is not available"
    >
      The model is not available.
    </Button>
  )
}

export default ModelNotAvailableButton
